// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Shadow_wrapper__J2CcC","dark":"Shadow_dark__XEBU0"};